// extracted by css-extract-rspack-plugin
export default {"cls1":"SourceText-cls1_jUN","cls2":"SourceText-cls2_njQ SourceText-cls1_jUN"};